// extracted by mini-css-extract-plugin
export default {"ChartPercent":"BarDCPercent_ChartPercent__9QGMz","BgChartPercent":"BarDCPercent_BgChartPercent__ir6RS","BgPercentActive":"BarDCPercent_BgPercentActive__ygP+T"};